<template>
    <TopNav />
    <div class="signup__form mx-auto">
        <p>
            <input type="email" placeholder="Email" v-model="email" />
        </p>
        <p>
            <input type="password" placeholder="Password" v-model="password" />
        </p>
        <SolidButton @click="handleLogin" text="Login" />
        <router-link to="signup">
            <p class="font-gray text-sm text-center mt-2">Create an account</p>
        </router-link>
    </div>
</template>

<script>
import SolidButton from "@/components/SolidButton.vue";
import { ref } from "vue";
import store from "@/store";
import { getAuth, signInWithEmailAndPassword } from "firebase/auth";
import { getFirestore, doc, getDoc } from "firebase/firestore";
import TopNav from "@/components/TopNav.vue";
import router from "@/router";

export default {
    name: "LoginView",
    components: {
        SolidButton,
        TopNav,
    },
    setup() {
        const email = ref("");
        const password = ref("");

        const handleLogin = () => {
            if (email.value.length != 0 && password.value.length != 0) {
                const auth = getAuth();
                signInWithEmailAndPassword(auth, email.value, password.value)
                    .then((userCredential) => {
                        // Signed in
                        const user = userCredential.user;
                        const db = getFirestore();

                        // fetch user from DB
                        const docRef = doc(db, "users", user.uid);
                        getDoc(docRef)
                            .then((doc) => {
                                const current_user = doc.data();

                                // Store in state
                                store.dispatch("setCurrentUser", current_user);
                                router.push("/dashboard");
                            })
                            .catch(() =>
                                console.log("Failed to fetch user from DB")
                            );
                    })
                    .catch((error) => {
                        const errorCode = error.code;
                        const errorMessage = error.message;
                        // ..
                        console.log(errorCode);
                        console.log(errorMessage);
                    });
            } else {
                alert("Looks like you forgot to fill something!");
            }
        };

        return {
            email,
            password,
            handleLogin,
        };
    },
};
</script>

<style lang="scss"></style>
